import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Popconfirm, Row, Table, Tag } from 'antd';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../../../assets/colors/dark';
import FormCustom from '../../../../components/FormCustom';
import { groupFieldsByType } from '../../utils.js';

const SettingPerDevice = ({
  keyTable,
  devicesActive,
  formExpand,
  onFinishPerDevice,
  initialPerDevice,
  service,
  checkUpdatePerDevice,
  setCheckUpdatePerDevice,
  setKeyTable,
  expKeys,
  setExpKeys,
  handleTableChangeActive,
  isLoadActiveLicense,
}) => {
  const { t } = useTranslation();

  const parsedConfig = useMemo(() => {
    if (!service?.configurationInput) return null;
    try {
      return JSON.parse(service.configurationInput);
    } catch {
      return null;
    }
  }, [service]);

  const perDeviceConfig = parsedConfig?.perDevice;
  const hasPerDevice = Array.isArray(perDeviceConfig)
    ? perDeviceConfig.length > 0
    : Boolean(perDeviceConfig && Object.keys(perDeviceConfig).length > 0);

  if (!hasPerDevice) return null;

  const dataSource =
    devicesActive?.data?.map((device) => ({
      ...device,
      key: device.serial,
    })) ?? [];

  return (
    <Col span={16}>
      <Table
        key={keyTable}
        dataSource={dataSource}
        expandable={{
          expandedRowRender: (record) => (
            <Form
              form={formExpand}
              name="register-service"
              layout="vertical"
              onFinish={(value) => onFinishPerDevice(value, record)}
              initialValues={
                (record?.service?.configuration &&
                  JSON.parse(record?.service?.configuration)) ??
                initialPerDevice ??
                {}
              }
            >
              {Array.isArray(perDeviceConfig) ? (
                <div>
                  {groupFieldsByType(perDeviceConfig).map((grp, grpIdx) => (
                    <Row gutter={32} style={{ width: '100%' }} key={grpIdx}>
                      {grp.items.map((item, index) => (
                        <FormCustom
                          key={index}
                          spanLayout={
                            item?.type === 'boolean' ||
                              [
                                'region',
                                'chainpoint',
                                'directionIn',
                                'period-minute',
                              ].includes(item?.type)
                              ? 24
                              : 12
                          }
                          data={item}
                          dataSerial={record}
                          formExpand={formExpand}
                          disabled={checkUpdatePerDevice}
                        />
                      ))}
                    </Row>
                  ))}
                  <Row>
                    <Col span={24}>
                      <Form.Item style={{ width: '100%', marginTop: '8px' }}>
                        <Button
                          disabled={checkUpdatePerDevice}
                          type="primary"
                          htmlType="submit"
                        >
                          {t('Update')}
                        </Button>
                        <Popconfirm
                          placement="top"
                          title={t('Are you sure？')}
                          okText={t('Yes')}
                          onConfirm={() => {
                            setKeyTable(Math.random());
                            const dataConfigurationTemp =
                              record?.service?.configuration &&
                              JSON.parse(record?.service?.configuration);
                            formExpand.setFieldsValue(
                              dataConfigurationTemp &&
                                Object.keys(dataConfigurationTemp).length > 0
                                ? dataConfigurationTemp
                                : initialPerDevice ?? {}
                            );
                          }}
                          cancelText={t('No')}
                        >
                          <Button
                            disabled={checkUpdatePerDevice}
                            style={{ marginLeft: '10px' }}
                          >
                            {t('Restore')}
                          </Button>
                        </Popconfirm>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              ) : (
                <Row gutter={16} style={{ width: '100%' }}>
                  {Object.entries(perDeviceConfig || {}).map(
                    ([moduleKey, moduleData]) => {
                      const isMultiple = moduleData?.isMore === 1;
                      const title =
                        moduleData?.fieldDisplay ||
                        moduleData?.title ||
                        moduleKey;
                      const fieldGroups = groupFieldsByType(moduleData?.fields);

                      return (
                        <Col
                          span={24}
                          key={moduleKey}
                          style={{ marginBottom: 16 }}
                        >
                          <div
                            style={{
                              padding: '16px',
                              backgroundColor: '#1f1f1f',
                              border: '1px solid #303030',
                              borderRadius: '6px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                color: '#fff',
                                marginBottom: '16px',
                              }}
                            >
                              {title}
                            </div>

                            {isMultiple ? (
                              <Form.List name={moduleKey}>
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(
                                      (
                                        { key, name, ...restField },
                                        idx
                                      ) => (
                                        <div
                                          key={key}
                                          style={{
                                            padding: '12px',
                                            marginBottom: '16px',
                                            border: '1px dashed #434343',
                                            borderRadius: '4px',
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              marginBottom: '12px',
                                              color: '#aaa',
                                            }}
                                          >
                                            <span style={{ fontWeight: '500' }}>
                                              {title} #{idx + 1}
                                            </span>
                                            {!checkUpdatePerDevice && (
                                              <Button
                                                type="text"
                                                danger
                                                size="small"
                                                onClick={() => remove(name)}
                                              >
                                                {t('Delete')}
                                              </Button>
                                            )}
                                          </div>
                                          {fieldGroups.map((grp, grpIdx) => (
                                            <Row gutter={16} key={grpIdx}>
                                              {grp.items.map((fItem, fIdx) => (
                                                <FormCustom
                                                  key={fIdx}
                                                  spanLayout={
                                                    fItem?.type === 'boolean' ||
                                                      [
                                                        'region',
                                                        'chainpoint',
                                                        'directionIn',
                                                        'period-minute',
                                                      ].includes(fItem?.type)
                                                      ? 24
                                                      : 12
                                                  }
                                                  data={fItem}
                                                  namePath={[name, fItem.field]}
                                                  dataSerial={record}
                                                  formExpand={formExpand}
                                                  disabled={
                                                    checkUpdatePerDevice
                                                  }
                                                />
                                              ))}
                                            </Row>
                                          ))}
                                        </div>
                                      )
                                    )}
                                    {!checkUpdatePerDevice && (
                                      <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                        style={{
                                          width: '100%',
                                          marginBottom: '16px',
                                        }}
                                      >
                                        {t('Add')} {title}
                                      </Button>
                                    )}
                                  </>
                                )}
                              </Form.List>
                            ) : (
                              <div>
                                {fieldGroups.map((grp, grpIdx) => (
                                  <Row gutter={16} key={grpIdx}>
                                    {grp.items.map((fItem, fIdx) => (
                                      <FormCustom
                                        key={fIdx}
                                        spanLayout={
                                          fItem?.type === 'boolean' ||
                                            [
                                              'region',
                                              'chainpoint',
                                              'directionIn',
                                              'period-minute',
                                            ].includes(fItem?.type)
                                            ? 24
                                            : 12
                                        }
                                        data={fItem}
                                        namePath={[moduleKey, fItem.field]}
                                        dataSerial={record}
                                        formExpand={formExpand}
                                        disabled={checkUpdatePerDevice}
                                      />
                                    ))}
                                  </Row>
                                ))}
                              </div>
                            )}
                          </div>
                        </Col>
                      );
                    }
                  )}
                  <Col span={24}>
                    <Form.Item style={{ width: '100%' }}>
                      <Button
                        disabled={checkUpdatePerDevice}
                        type="primary"
                        htmlType="submit"
                      >
                        {t('Update')}
                      </Button>
                      <Popconfirm
                        placement="top"
                        title={t('Are you sure？')}
                        okText={t('Yes')}
                        onConfirm={() => {
                          setKeyTable(Math.random());
                          const dataConfigurationTemp =
                            record?.service?.configuration &&
                            JSON.parse(record?.service?.configuration);
                          formExpand.setFieldsValue(
                            dataConfigurationTemp &&
                              Object.keys(dataConfigurationTemp).length > 0
                              ? dataConfigurationTemp
                              : initialPerDevice ?? {}
                          );
                        }}
                        cancelText={t('No')}
                      >
                        <Button
                          disabled={checkUpdatePerDevice}
                          style={{ marginLeft: '10px' }}
                        >
                          {t('Restore')}
                        </Button>
                      </Popconfirm>
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Form>
          ),
        }}
        expandedRowKeys={expKeys}
        onExpand={(check, record) => {
          setExpKeys(check ? [record?.serial] : []);
          setKeyTable(Math.random());
          setCheckUpdatePerDevice(true);
          const dataConfigurationTemp =
            record?.service?.configuration &&
            JSON.parse(record?.service?.configuration);
          formExpand.setFieldsValue(
            dataConfigurationTemp &&
              Object.keys(dataConfigurationTemp).length > 0
              ? dataConfigurationTemp
              : initialPerDevice ?? {}
          );
        }}
        pagination={devicesActive && devicesActive.pagination}
        loading={devicesActive && devicesActive.loading}
        onChange={handleTableChangeActive}
        columns={[
          {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name_device',
            sorter: (a, b) => a.name.localeCompare(b.name),
          },
          {
            title: t('State'),
            key: 'log_action',
            width: 200,
            render: (device) =>
              isLoadActiveLicense.some((serial) => serial === device.serial) ? (
                <Tag
                  style={{ width: 120, textAlign: 'center' }}
                  color={colorsDark.$warning}
                >
                  {t('Activating')}
                </Tag>
              ) : device.service ? (
                <Tag
                  style={{ width: 120, textAlign: 'center' }}
                  color={colorsDark.$online}
                >
                  {t('Activated')}
                </Tag>
              ) : (
                <Tag
                  style={{ width: 120, textAlign: 'center' }}
                  color={colorsDark.$offline}
                >
                  {t('Not activated')}
                </Tag>
              ),
          },
          {
            title: t('Active date'),
            key: 'log_activatedAt',
            dataIndex: 'service',
            sorter: (a, b) =>
              a.service?.activatedAt?.localeCompare(b.service?.activatedAt),
            render: (serviceRecord) =>
              serviceRecord?.activatedAt
                ? moment(serviceRecord.activatedAt).format('DD-MM-YYYY')
                : '',
          },
          {
            title: t('License Code'),
            key: 'service_license_code_device',
            dataIndex: 'service',
            render: (serviceRecord) =>
              serviceRecord?.licenseCode ? serviceRecord?.licenseCode : '',
          },
          {
            title: t('License Info'),
            key: 'service_license_info_device',
            dataIndex: 'service',
            render: (serviceRecord) =>
              serviceRecord?.licenseInfo ? serviceRecord?.licenseInfo : '',
          },
          {
            title: t('Action'),
            key: 'actions ',
            render: (record) => (
              <div className="manager-member-actions">
                <div
                  className="edit-button"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setExpKeys([record?.serial]);
                    setKeyTable(Math.random());
                    setCheckUpdatePerDevice(false);
                    const dataConfigurationTemp =
                      record?.service?.configuration &&
                      JSON.parse(record?.service?.configuration);
                    formExpand.setFieldsValue(
                      dataConfigurationTemp &&
                        Object.keys(dataConfigurationTemp).length > 0
                        ? dataConfigurationTemp
                        : initialPerDevice ?? {}
                    );
                  }}
                >
                  <EditOutlined /> {t('Edit')}
                </div>
              </div>
            ),
          },
        ]}
      />
    </Col>
  );
};

export default SettingPerDevice;
